module.exports = __webpack_public_path__ + "static/about-2-755ed8ec454a4c568b1c29d506b74850.jpg";